import { ChangeOrderForm } from 'interfaces/ChangeOrderForm';

import { NEW_CHANGE_ORDER_FORM } from './constants';

/**
 * Interface for the create form parameters
 */
interface CreateFormParams {
  /** User who is creating the Change Order */
  user: string;
}

/**
 * Creates a new Change Order form with initial data
 * 
 * @param params - Object containing user information
 * @param params.user - Email of the user creating the Change Order
 * @returns A new Change Order form populated with initial data
 * 
 * @example
 * const newForm = createNewChangeOrderForm({ user: 'user@example.com' });
 */
export function createNewChangeOrderForm({ user }: CreateFormParams): ChangeOrderForm {
  return {
    ...NEW_CHANGE_ORDER_FORM,
    generalInformation: {
      ...NEW_CHANGE_ORDER_FORM.generalInformation,
      requesterEmail: user
    }
  };
}
